import React, {useState, useEffect} from 'react'
import {firebaseAnalytics} from '../../services/firebase'
import {Helmet} from 'react-helmet'
import { connect } from 'react-redux'
import './portfolio2.css'
import moment from 'moment'
import {Link} from 'react-router-dom'




const Team = (props) => {
    //get props
    const user = props.user
    const teams = props.teams

    const t = props.t
    const e = props.e

    const [change, setChange] = useState(t && t.change ? t.change.day : 0)

    useEffect(()=>{
        if(props.t && props.t.change){
            if(props.time === '1D'){
                setChange(t.change.day)
            }else if(props.time === '1W'){
                setChange(t.change.week)
            }else if(props.time === '1M'){
                setChange(t.change.month)
            }
        }
    },[props])

    return(
        <div style={{marginLeft: '3%', marginRight: '3%'}}>
            <Link to={`/Teams/${t.team.name}`} style={{color: 'black'}}>
            <div style={{display: 'inline-block', width: '14%', verticalAlign: 'top', textAlign: 'right'}}>
                <div><img className="team-img-port2" src={`https://firebasestorage.googleapis.com/v0/b/sports-market.appspot.com/o/jerseys%2F${t.team.name}.png?alt=media&token=23f2917a-f1ad-48c5-a272-54be86a32af1`} /></div>
                
            </div>
            <div style={{display: 'inline-block', width: '47%', paddingLeft: '2%', fontSize: '1.3em', verticalAlign: 'top'}}>
                <div>Sim{t.team.name}</div>
                <div style={{fontSize: '0.6em', fontWeight: '200'}}>{e.amount && e.amount.toFixed(4)} shares</div>
            </div>
            <div style={{display: 'inline-block', width: '36%', textAlign: 'right', paddingRight: '3%', verticalAlign: 'bottom'}}>
                <div style={{fontSize: '1.1em'}}>${(e.amount * t.asking_price).toFixed(2)}</div>
                <div style={{fontSize: '0.8em', fontWeight: '200'}}>{(change * 100).toFixed(2)}%</div>
            </div>
            <hr style={{padding: '0', margin: '5px'}} />
            </Link>
            
            
        </div>
    )
}

const mapStateToProps = (state) => ({
    user: state.user.user,
    teams: state.teams.teams.teams
});

export default connect(mapStateToProps)(Team)